import React from 'react'
import PropTypes from 'prop-types'
import Link, { LINK_BEHAVIORS } from 'components/Link'
import './CountryPageLinksBlock.scss'

const CountryPageLink = ({ link, description }) => {
    return (
        <React.Fragment>
            {link && (
                <Link 
                    className="country-page-links-block__link"
                    behavior={LINK_BEHAVIORS.card}
                    {...link}
                />
            )}
            {description &&<div className="country-page-links-block__link-description">{description}</div>}
        </React.Fragment>
    )
}

CountryPageLink.propTypes = {
    link: PropTypes.exact(Link.propTypes),
    description: PropTypes.string
}

export default CountryPageLink
